import { buildColorPropsSDKFactoryCreator } from './colorPropsSDKFactoryBuilder';
import type {
  IColorSDK,
  IColorWithStatesSDK,
} from './colorPropsSDKFactoryBuilder';

export type IBackgroundColorSDK = IColorSDK<'backgroundColor'>;

export type IBackgroundColorWithStateSDK =
  IColorWithStatesSDK<'backgroundColor'>;

export const createBackgroundColorPropsSDKFactory =
  buildColorPropsSDKFactoryCreator('backgroundColor');
